import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Hr/reports/AttendanceReport/RepresentativeReportAttendanceAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class RepresentativeReportAttendanceActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Hr/reports/AttendanceReport/RepresentativeReportAttendance")
	}

	render() {
		return (
			<Activity 
				name="RepresentativeReportAttendance"
				RenderedComponent={this.RenderedComponent}
				context="RepresentativeReportAttendance"
				action="RepresentativeReportAttendance"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(RepresentativeReportAttendanceActivity)
